export default {
  // 页面标题
  title: 'Billing & Payments',
  
  // 账单信息部分
  billingInformation: {
    title: 'Billing information',
    edit: 'Edit',
    save: 'Save',
    email: {
      label: 'Billing email:',
      placeholder: 'Billing updates will be sent to this email'
    },
    companyProfile: {
      label: 'Company billing profile:',
      placeholder: 'Additional company information to be shown on invoices, e.g. Address, P.O. number, etc.'
    }
  },
  
  // 支付方式部分
  paymentMethod: {
    setup: {
      title: 'Set up payment method',
      button: 'Set up',
      updateButton: 'Update'
    },
    availableFunds: {
      title: 'Available funds',
      currency: 'USD',
      description: 'All major credit and debit cards are supported. For alternative payment methods such as bank transfer, please contact',
      depositButton: 'Deposit funds'
    },
    freeCredits: {
      title: 'Free credits',
      currency: 'USD',
      description: 'Free credits are automatically applied, covering up to 10% of your influencer payments upon confirming influencers.'
    },
    card: 'Card'
  },
  
  // 账单历史部分
  billingHistory: {
    billingTitle: 'Billing history',
    depositTitle: 'Deposit history',
    downloadButton: 'Download details',
    influencerNamePlaceholder: 'Influencer name',
    table: {
      date: 'Date',
      bonus: 'Bonus',
      totalCredited: 'Total credited',
      totalAmount: 'Total amount',
      orderId: 'Order ID',
      campaignName: 'Campaign name',
      influencerName: 'Influencer name',
      paymentStatus: 'Payment status',
      status: 'Status'
    },
    pagination: {
      previous: 'Previous',
      next: 'Next'
    }
  },
  
  // 支付状态
  paymentStatus: {
    paid: 'Paid to influencer',
    refunded: 'Refunded',
    onHold: 'On hold in escrow',
    default: '-'
  },
  
  // 消息提示
  messages: {
    emailRequired: 'Please enter your email address.',
    nameRequired: 'Please enter your name address.',
    saveSuccess: 'Save successfully!',
    downloadError: '{error}'
  },
  
  // 模态框
  modal: {
    companyProfile: {
      title: 'Company billing profile',
      submit: 'Submit'
    }
  }
};
